<script>
    import { beforeUpdate, createEventDispatcher, onMount } from 'svelte';
    import CompanyDetails from "./CompanyDetails.svelte";
    import { fetchCompanies, saveCompany } from '../../data';
    
    export let company = { }
    export let companyId = null;
    
    // we only want to save the Compony to the database if we have fetched
    // the Company details from the database, otherwise, the calling component
    // should 'bind' the Company object to this compnent and handle the save.
    export let saveToDB = false;
    
    const dispatch = createEventDispatcher()
    
    if (companyId) {
        saveToDB = true
    }
    if (companyId) {
        let promiseCompany = fetchCompanies(companyId)
        promiseCompany.then((value) => {
            company=value;
            if (company && !company.contacts) company.contacts = company.people || [];
        });
    }
    if (!company && !companyId ) {
        company = {
            "ABN": "",
            "ACN": "",
            "address": {},
            "name": "",
            "contacts": [ ],
            "people": [ ],
            "phone": ""
        }
    }
    if (company && !company.contacts) {
        company.contacts = company.people || [];
    }
        
    async function save() {
        if (saveToDB) {
            company = await saveCompany(company)
        }
        dispatch("company-saved", company)
    }

    function checkAddress() {
        let c = company
        console.log(c)
        dispatch("address-updated")
    }
</script>

<CompanyDetails bind:company={company} 
                on:company-saved={save} 
                on:close={()=>dispatch("company-closed")} 
                on:address-updated={()=>dispatch("address-updated")}/>
